import React, {
    useCallback, useContext, useEffect, useState,
} from 'react';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/async';
import HotelsRepository from 'services/repositories/HotelsRepository';
import { debounce } from 'lodash';
import { getSelectHelpers } from 'utils/theme-helpers';
import { ThemeContext } from 'utils/context';

function SelectHotel({
    isLoading, id, className, onChange, value,
})
{
    const [isLoadingHotels, setIsLoadingHotels] = useState(false);
    const [currentValue, setCurrentValue] = useState(value);
    const {
        darkMode,
    } = useContext(ThemeContext);
    const styles = getSelectHelpers({ error: false, darkMode, controlPadding: '0px 6px' });

    useEffect(() =>
    {
        if (value === null)
        {
            setCurrentValue(null);
        }
    }, [value]);

    const loadOptions = useCallback(
        debounce((inputValue, callback) =>
        {
            searchHotels(inputValue).then((options) => callback(options));
        }, 500),
        [],
    );
    const searchHotels = async (criteria) =>
    {
        if (criteria.length < 3)
        {
            return [];
        }

        setIsLoadingHotels(true);
        const result = await (new HotelsRepository()).search(criteria);
        setIsLoadingHotels(false);
        return result?.response ?? [];
    };

    return (
        <AsyncSelect
            getOptionLabel={(option) => `${option.name}${option.destination ? ` - ${option.destination.name}` : ''}`}
            getOptionValue={(option) => option.id}
            isDisabled={isLoading}
            async
            styles={styles}
            cacheOptions
            defaultOptions
            isLoading={isLoadingHotels}
            noOptionsMessage={() => 'No Hotels found, At least 3 characters required'}
            loadOptions={loadOptions}
            onChange={(newValue) =>
            {
                setCurrentValue(newValue);
                onChange(newValue);
            }}
            value={currentValue}
            classNames={{
                control: () => className,
            }}
            id={id}
        />
    );
}

SelectHotel.defaultProps = {
    isLoading: false,
    className: '',
    id: 'selectHotelSearch',
    value: null,
    onChange: () =>
    {},
};

SelectHotel.propTypes = {
    className: PropTypes.string,
    isLoading: PropTypes.bool,
    id: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.number,
};

export default SelectHotel;
